import { CRM_API, RequestHelper } from "utils";

const RUTA = "facturacitrus";
export const FacturaCitrusService = (() => {
  const listado = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get(`${RUTA}`, params);
    });
  };

  const obtenerLinkPagoFactura = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).post(`${RUTA}/ObtenerLinkPagoFactura`, data);
    });
  };

  const actualizarFacturaRecurrente = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).post(`${RUTA}/actualizarFacturaRecurrente`, data);
    });
  };

  const actualizarPorNumeroFactura = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).post(`${RUTA}/actualizarPorNumeroFactura`, data);
    });
  };

  const descargarFormularioAutorizacionCargoTarjetaCredito = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get(
        `${RUTA}/${params}/descargarFormularioAutorizacionCargoTarjetaCredito`,
        params,
        true
      );
    });
  };

  const procesarFormularioAutorizacion = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).postWithFiles(`${RUTA}/procesarFormularioAutorizacion`, data);
    });
  };

  const procesarComprobantePago = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).postWithFiles(`${RUTA}/procesarComprobantePago`, data);
    });
  };

    const buscarReporte = function (args) {
      return new Promise((res) => res(args)).then((params) => {
        return RequestHelper(CRM_API).get(`${RUTA}/${params}/reporte`, params);
      });
    };


  return {
    listado,
    obtenerLinkPagoFactura,
    actualizarFacturaRecurrente,
    descargarFormularioAutorizacionCargoTarjetaCredito,
    procesarFormularioAutorizacion,
    procesarComprobantePago,
    actualizarPorNumeroFactura,
    buscarReporte
  };
})();